import React from 'react';
import './index.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';

interface LoadingProps{
    // color?: string,
    center?: boolean,
    style?: {};
}

export default function Loading(props: LoadingProps) {
  const { center, style } = props;
  return (
    <div className={center ? 'center' : 'default'} style={style}>
      <section>
        <span>
          <FontAwesomeIcon className="cog-1" icon={faCog} spin />
          <FontAwesomeIcon className="cog-2" icon={faCog} spin />
          <FontAwesomeIcon className="cog-3" icon={faCog} spin />
        </span>
      </section>
    </div>
  );
}
